export const checkAsylumStatus = (state, input, type) =>
  state.query.asylumStatus.find(status => {
    return status[type] === input[type]
  })



// WEBPACK FOOTER //
// ./src/store/helpers.js